import { Box, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { ThreeDot } from "../DropDown/ThreeDot";
import SearchIcon from "@mui/icons-material/Search";
import { visuallyHidden } from "@mui/utils";
import PropTypes from "prop-types";
import { useThemes } from "../Theme/theme";
import { memo } from "react";

const  EnhancedTableHead=memo((props)=> {
    const {
        onSelectAllClick = () => { },
        order,
        orderBy,
        numSelected,
        rowCount,
        onRequestSort = () => { },
        onDelete,
        setEnableSearch = () => { },
        EnableSearch,
        headCell,
        disableSort
    } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    const { theme } = useThemes();
    return (
        <TableHead>
            <TableRow sx={{
                ".MuiTableCell-root": {
                    backgroundColor: `${theme.palette.background.tablebg} !important`,
                },
                backgroundColor: "background.tablebg",
            }}>
             
                {headCell.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? "right" : "left"}
                        padding={headCell.disablePadding ? "none" : "normal"}
                        sortDirection={orderBy === headCell.id ? order : false}

                    //  sx={{maxWidth:headCell.width}}
                    >

                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexDirection: headCell.numeric ? "row-reverse" : "",
                                marginLeft:"10px"
                            }}
                        >
                            {headCell?.disableSort != true || disableSort != true ? (
                                <>
                                    <TableSortLabel
                                        active={
                                            orderBy === headCell.id
                                                ? true
                                                : "dueDate" === headCell.id &&
                                                    orderBy === "dueDateTimeStamp"
                                                    ? true
                                                    : false
                                        }
                                        direction={
                                            orderBy === "dueDateTimeStamp" || "InvoiceDateTimeStamp"
                                                ? order
                                                : orderBy === headCell.id
                                                    ? order
                                                    : "asc"
                                        }
                                        onClick={createSortHandler(headCell.id)}
                                    >
                                        <Box sx={{ display: "flex" }}>
                                            <Box sx={{ whiteSpace: "nowrap" }}>{headCell.label}</Box>
                                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                                {orderBy === headCell.id ? (
                                                    <Box
                                                        //  component="span"
                                                        sx={visuallyHidden}
                                                    >
                                                        {order === "desc"
                                                            ? "sorted descending"
                                                            : "sorted ascending"}
                                                    </Box>
                                                ) : null}
                                                {EnableSearch &&
                                                    <SearchIcon
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setEnableSearch((prev) => !prev);
                                                        }}
                                                        sx={{ marginLeft: "10px" }}
                                                        fontSize="small"
                                                    />
                                                }
                                            </Box>
                                        </Box>
                                    </TableSortLabel>
                                </>
                            ) : (
                                headCell.label
                            )}
                        </Box>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
})

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

export default EnhancedTableHead